import { Actions, Mutations } from "@/store/enums/StoreEnums";
import store from "@/store";

const state = () => {
  return {
    corpId: '',
    corpStatus: 1,
    systemName: '',
    iconPath: '',
    bannerPath: '',
    bannerBgColor: '#0548d1',
    navStyle: 'zhi-lg-2',
    footerInfo: 'Copyright © 2013-2024 智点科技',
    footerBeian: '京ICP备2022010891号-1'
  };
};

// getters
const getters = {
  corpId: (state) => {
    return state.corpId
  },
  corpStatus: (state) => {
    return state.corpStatus
  },
  systemName: (state) => {
    return state.systemName
  },
  iconPath: (state) => {
    return state.iconPath
  },
  bannerPath: (state) => {
    return state.bannerPath
  },
  bannerBgColor: (state) => {
    return state.bannerBgColor
  },
  navStyle: (state) => {
    return state.navStyle
  },
  footerInfo: (state) => {
    return state.footerInfo
  },
  footerBeian: (state) => {
    return state.footerBeian
  },
};

// actions
const actions = {
};

// mutations
const mutations = {
  [Mutations.SET_CORP_INFO](state, payload) {
    if(payload['id']){
      state.corpId = payload['id'];
    }
    if(payload['status']){
      state.corpStatus = payload['status'];
    }
    if(payload['systemName']){
      state.systemName = payload['systemName'];
      document.title = state.systemName;
    }
    if(payload['iconPath']){
      state.iconPath = payload['iconPath'];
    }
    if(payload['bannerPath']){
      state.bannerPath = payload['bannerPath'];
    }
    if(payload['navStyle']){
      state.navStyle = payload['navStyle'];
    }
    if(payload['footerInfo']){
      state.footerInfo = payload['footerInfo'];
    }
    if(payload['footerBeian']){
      state.footerBeian = payload['footerBeian'];
    }
  },
};

export default {
  // namespaced: true,
  state,
  getters,
  actions,
  mutations
};
